// ============================================================================
// 📁 FILE: src/modules/ticket/components/detail/GeneralInfoBlock.js
// ============================================================================

import React from "react";

export default function GeneralInfoBlock({ ticket }) {
  if (!ticket) return null;

  return (
    <div className="tf-block">
      <div className="tf-block-title">General Information</div>

      {/* Ticket Number */}
      <div className="tf-info-row">
        <div className="label">Ticket Number:</div>
        <div className="value">{ticket.ticket_number || "-"}</div>
      </div>

      {/* Status */}
      <div className="tf-info-row">
        <div className="label">Status:</div>
        <div className="value">{ticket.status || "-"}</div>
      </div>

      {/* Priority */}
      <div className="tf-info-row">
        <div className="label">Priority:</div>
        <div className="value">{ticket.priority || "-"}</div>
      </div>

      {/* Severity */}
      <div className="tf-info-row">
        <div className="label">Severity:</div>
        <div className="value">{ticket.severity || "-"}</div>
      </div>

      {/* Reported By */}
      <div className="tf-info-row">
        <div className="label">Reported By:</div>
        <div className="value">
          {ticket.reported_by?.name || "Unknown"}
        </div>
      </div>

      {/* Assigned To */}
      <div className="tf-info-row">
        <div className="label">Assigned To:</div>
        <div className="value">
          {ticket.assigned_to?.name || "Unassigned"}
        </div>
      </div>

      {/* ⭐ DESCRIPTION (ADDED NOW) */}
      <div className="tf-info-row" style={{ marginTop: "10px" }}>
        <div className="label">Description:</div>
        <div className="value" style={{ whiteSpace: "pre-wrap" }}>
          {ticket.description || "-"}
        </div>
      </div>

    </div>
  );
}
